module.exports = __webpack_public_path__ + "media/application/images/svgs/thermometer-548283cbf773d53e37f24806c640fff9.svg";